import React from 'react';
import PropTypes from 'prop-types';
import { Overlay, Popover } from 'react-bootstrap';
import styles from './styles.module.styl';

export default class PopoverStickOnHover extends React.Component {
  constructor(props) {
    super(props);

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);

    this.state = {
      showPopover: false,
    };
  }

  componentWillUnmount() {
    if (this.setTimeoutConst) {
      clearTimeout(this.setTimeoutConst);
    }
  }

  handleMouseEnter() {
    const { delay, onMouseEnter } = this.props;

    this.setTimeoutConst = setTimeout(() => {
      this.setState({ showPopover: true }, () => {
        if (onMouseEnter) {
          onMouseEnter();
        }
      });
    }, delay);
  }

  handleMouseLeave() {
    clearTimeout(this.setTimeoutConst);
    this.setState({ showPopover: false });
  }

  render() {
    const { popover, children, placement, title } = this.props;

    const childNode = React.Children.map(children, (child) =>
      React.cloneElement(child, {
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        ref: (node) => {
          this.childNodeRef = node;
          const { ref } = child;
          if (typeof ref === 'function') {
            ref(node);
          }
        },
      })
    )[0];

    return (
      <React.Fragment>
        {childNode}
        <Overlay show={this.state.showPopover} placement={placement} target={this.childNodeRef} shouldUpdatePosition>
          <Popover
            onMouseEnter={() => {
              this.setState({ showPopover: true });
            }}
            onMouseLeave={this.handleMouseLeave}
            id={`${title}-popver`}
            title={title}
            className={styles.popover}
          >
            {popover}
          </Popover>
        </Overlay>
      </React.Fragment>
    );
  }
}

PopoverStickOnHover.defaultProps = {
  delay: 0,
  placement: 'top',
};

PopoverStickOnHover.propTypes = {
  title: PropTypes.string,
  delay: PropTypes.number,
  placement: PropTypes.string,
  onMouseEnter: PropTypes.func,
  children: PropTypes.element.isRequired,
  popover: PropTypes.node.isRequired,
};
